/* Tu Beauty / premium + volume / 2026-09-30. Progressive enhancement; native cart remains authoritative. */
(() => {
  'use strict';
  if (window.TBPremium2027) return;
  window.TBPremium2027 = {version: '1.0.1'};
  const states = new Map();
  let cart = null, cartRequest = null, activeForm = null, frame = 0;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const money = n => new Intl.NumberFormat('es-CO', {style:'currency',currency:'COP',maximumFractionDigits:0}).format(n / 100);
  function quote(price, qty) {
    const subtotal = price * qty;
    const rate = subtotal >= 35000000 ? 30 : (subtotal >= 20000000 || qty >= 24) ? 20 : 0;
    return {subtotal,rate,total:subtotal-Math.round(subtotal*rate/100)};
  }
  function canQuote(s) {
    const currency = cart ? cart.currency : s.data.currency;
    const active = window.Currency && window.Currency.currentCurrency;
    const plan = s.form.querySelector('[name="selling_plan"]');
    return currency === 'COP' && (!active || active === 'COP') && !s.data.requiresSellingPlan && !(plan && plan.value);
  }
  async function readCart() {
    if (cartRequest) return cartRequest;
    cartRequest = fetch(root+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}})
      .then(r=>{if(!r.ok)throw Error('cart');return r.json();})
      .then(data=>{cart=data;states.forEach(refresh);})
      .catch(()=>{/* Keep the native form usable if cart lookup is unavailable. */})
      .finally(()=>{cartRequest=null;});
    return cartRequest;
  }
  function selected(s) {
    const values = [];
    s.form.querySelectorAll('select[data-variant-input],input[data-variant-input]:checked').forEach(el=>{
      const i = Number(String(el.dataset.index || '').replace('option','')) - 1;
      if(i>=0)values[i]=el.value;
    });
    if (values.length) return s.data.variants.find(v=>v.options.every((value,i)=>value===values[i])) || null;
    const el=s.form.querySelector('[name="id"]');
    return s.data.variants.find(v=>String(v.id)===String(el && el.value)) || null;
  }
  function capacity(v) {
    if(!v || !v.available)return 0;
    const used = cart ? cart.items.reduce((n,item)=>n+(String(item.variant_id)===String(v.id)?item.quantity:0),0) : 0;
    let max = Number(v.maximum)>0 ? Math.max(0,Number(v.maximum)-used) : Infinity;
    if(v.tracked && v.policy!=='continue') {
      max=Math.min(max,Math.max(0,Number(v.inventory)-used));
    }
    return max;
  }
  function allowed(q,v,max) {
    const min=Number(v.minimum)||1, step=Number(v.increment)||1;
    return Number.isInteger(q) && q>=min && q<=max && (q-min)%step===0;
  }
  function nextQuantity(q,v) {
    const min=Number(v.minimum)||1, step=Number(v.increment)||1;
    return min+Math.max(0,Math.ceil((q-min)/step))*step;
  }
  function choose(s,n) {
    s.quantity.value=String(n);
    s.quantity.dispatchEvent(new Event('input',{bubbles:true}));
    s.quantity.dispatchEvent(new Event('change',{bubbles:true}));
    refresh(s);
  }
  function refresh(s) {
    if(!s.form.isConnected){states.delete(s.form);return;}
    const v=selected(s), max=capacity(v), validPrice=v && Number(v.price)>0;
    const qty=Number(s.quantity.value), estimate=canQuote(s);
    s.variant=v;
    const benefit=s.form.closest('.product-section')?.querySelector('.descuento-por-cantidad');
    if(benefit)benefit.hidden=!estimate;
    if(v) {
      s.quantity.min=String(v.minimum||1);s.quantity.step=String(v.increment||1);
      if(Number.isFinite(max) && max>=0)s.quantity.max=String(max);else s.quantity.removeAttribute('max');
    }
    s.picker.hidden=!v || !validPrice || max<=1;
    s.buttons.forEach(btn=>{
      const n=Number(btn.dataset.tbQty), ok=v && allowed(n,v,max);
      btn.disabled=!ok;btn.setAttribute('aria-pressed',String(n===qty));
      let label=!ok ? 'No disponible' : '';
      if(ok && estimate) {
        const p=quote(v.price,n);
        label=money(p.total)+' total'+(p.rate?' · −'+p.rate+'% estimado':'');
      }
      btn.querySelector('[data-tb-pack-price]').textContent=label;
    });
    let status='';
    if(!v)status='Selecciona una variante disponible.';
    else if(max===0)status='Esta variante no tiene más unidades disponibles para agregar.';
    else if(!allowed(qty,v,max))status=Number.isFinite(max)?'Revisa la cantidad. Puedes agregar hasta '+max+' unidades de esta variante.':'Revisa la cantidad seleccionada.';
    else if(estimate && validPrice) {
      const p=quote(v.price,qty);
      status=(p.rate?'Total estimado: ':'Subtotal: ')+money(p.total)+' · '+money(p.total/qty)+' por unidad'+(p.rate?' · Beneficio del '+p.rate+'% estimado.':'.');
    }
    s.status.textContent=status;
    s.status.hidden=max===1 && v && allowed(qty,v,max);
    s.note.hidden=max<=1;
    const terms=s.form.querySelector('.tb-benefit-terms');if(terms)terms.hidden=max<=1 || !estimate;
    s.note.textContent=estimate?'Estimación solo de estas unidades, sin sumar el carrito actual. No acumulable. Impuestos y envío adicionales cuando correspondan; el carrito confirma el total.':'Selecciona la cantidad. Consulta precios, descuentos y disponibilidad finales en el carrito.';
    s.suggest.hidden=true;
    if(v && validPrice && estimate && qty>0 && max>qty) {
      const threshold=v.price*qty<20000000?20000000:v.price*qty<35000000?35000000:0;
      const target=threshold?nextQuantity(Math.ceil(threshold/v.price),v):0;
      if(target>qty && target<=max && target<=24 && allowed(target,v,max)) {
        s.suggest.hidden=false;s.suggest.dataset.tbTarget=String(target);
        s.suggest.textContent='Elegir '+target+' unidades · alcanzar '+(threshold===20000000?'20':'30')+'%';
      }
    }
    updateSticky();
  }
  function setup(scope=document) {
    scope.querySelectorAll('form.product-single__form').forEach(form=>{
      if(states.has(form))return;
      const config=form.querySelector('[data-tb-product-config]'), quantity=form.querySelector('[name="quantity"]');
      if(!config || !quantity)return;
      let data;try{data=JSON.parse(config.textContent);}catch(e){return;}
      const picker=form.querySelector('[data-tb-quantity-picker]');if(!picker)return;
      const s={form,data,quantity,picker,buttons:[...picker.querySelectorAll('[data-tb-qty]')],status:form.querySelector('[data-tb-volume-status]'),note:form.querySelector('[data-tb-volume-note]'),suggest:form.querySelector('[data-tb-volume-suggest]')};
      states.set(form,s);
      s.buttons.forEach(b=>b.addEventListener('click',()=>choose(s,Number(b.dataset.tbQty))));
      s.suggest.addEventListener('click',()=>choose(s,Number(s.suggest.dataset.tbTarget)));
      form.addEventListener('change',()=>{refresh(s);setTimeout(()=>refresh(s),80);});
      quantity.addEventListener('input',()=>refresh(s));
      form.addEventListener('submit',event=>{
        if(!quantity.checkValidity()) {event.preventDefault();event.stopImmediatePropagation();quantity.reportValidity();}
      },true);
      const price=form.closest('.product-section')?.querySelector('[data-product-price]');
      if(price)new MutationObserver(()=>refresh(s)).observe(price,{childList:true,characterData:true,subtree:true});
      refresh(s);
    });
    const wa=document.getElementById('btnWhatsApp');
    if(wa && !wa.dataset.tbAccessible) {
      wa.dataset.tbAccessible='true';wa.setAttribute('role','button');wa.tabIndex=0;wa.setAttribute('aria-label','Hablar con una asesora por WhatsApp');
      wa.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();wa.click();}});
    }
    document.querySelectorAll('form[role="search"],form[action*="/search"]').forEach(f=>f.classList.add('tb-search-form'));
    setupSticky();
  }
  function setupSticky() {
    const menu=document.querySelector('.site-nav__thumb-menu');if(!menu || menu.querySelector('[data-tb-sticky]'))return;
    const btn=document.createElement('button');btn.type='button';btn.className='tb-sticky-buy';btn.dataset.tbSticky='';btn.hidden=true;
    btn.addEventListener('click',()=>{
      if(!activeForm)return;
      const target=activeForm.form.querySelector('[data-add-to-cart]');
      if(target && !target.disabled && activeForm.quantity.checkValidity())target.click();
      else {activeForm.quantity.scrollIntoView({block:'center',behavior:'smooth'});activeForm.quantity.focus({preventScroll:true});}
    });
    menu.insertBefore(btn,menu.querySelector('.site-nav__thumb-cart'));
    const nav=menu.querySelector('.site-nav__thumb-button');if(nav)nav.setAttribute('aria-label','Abrir categorías');
    updateSticky();
  }
  function updateSticky() {
    const menu=document.querySelector('.site-nav__thumb-menu'), btn=menu?.querySelector('[data-tb-sticky]');if(!btn)return;
    activeForm=null;
    const blocked=document.body.matches('.screen-layer-open,.modal-open,.drawer--is-open,.slide-nav-open') || document.querySelector('.drawer.is-open,.drawer--is-open,.slide-nav.is-open');
    if(window.innerWidth<=768 && !blocked && !/INPUT|SELECT|TEXTAREA/.test(document.activeElement?.tagName||'')) {
      for(const s of states.values()) {
        if(!s.form.closest('#MainContent') || s.form.closest('.screen-layer') || !s.form.getClientRects().length)continue;
        const add=s.form.querySelector('[data-add-to-cart]');
        if(add && add.getClientRects().length && !add.disabled && add.getBoundingClientRect().bottom<0 && !add.classList.contains('btn--loading')) {activeForm=s;break;}
      }
    }
    const visible=Boolean(activeForm);btn.hidden=!visible;menu.classList.toggle('tb-has-sticky',visible);
    if(visible) {const q=Number(activeForm.quantity.value)||1;btn.textContent='Agregar '+q+(q===1?' unidad':' unidades');}
  }
  const schedule=()=>{if(!frame)frame=requestAnimationFrame(()=>{frame=0;updateSticky();});};
  document.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule,{passive:true});
  document.addEventListener('focusin',schedule);document.addEventListener('focusout',schedule);
  ['cart:updated','ajaxProduct:added','cart:refresh'].forEach(name=>document.addEventListener(name,readCart));
  document.addEventListener('click',e=>{if(e.target.closest('.js-drawer-open-cart'))readCart();});
  document.addEventListener('shopify:section:load',()=>setup());
  window.addEventListener('pageshow',()=>{setup();readCart();});
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)readCart();});
  function start() {
    setup();readCart();
    if(window.jQuery)window.jQuery(document).on('ajaxProduct:added.tb2027 cart:updated.tb2027',readCart);
    let pending=false;
    new MutationObserver(records=>{
      if(pending || !records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1 && (n.matches('form,.product-section') || n.querySelector('form.product-single__form')))))return;
      pending=true;requestAnimationFrame(()=>{pending=false;setup();});
    }).observe(document.body,{childList:true,subtree:true});
    new MutationObserver(schedule).observe(document.body,{attributes:true,attributeFilter:['class']});
  }
  if(document.readyState!=='complete')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
